<div class="wrapper-single-list-page">
  <tl-header></tl-header>
  <div class="wrapper-content-single-page">
    <div class="wrapper-header-single-list">
      <div class="header-single-list">
        <div class="wrapper-info-single-list">
          <div class="wrapper-img-single-list">
            <img [src]="list?.lyst_image_url !== null ? list?.lyst_image_url : 'assets/images/no-image.png'" (click)="list?.lyst_image_url !== null ? selectedMedia = list : selectedMedia = null" alt="">
          </div>
          <div class="tl-d-flex tl-flex-column">
            <div class="info-single-list">
              <div class="wrapper-badges">
                <div class="badge yellow">
                  <span>{{list?.lyst_items_count}} {{'LISTS.items' | translate}}</span>
                </div>
                <div *ngIf="list?.visibility === 0" class="badge gray">
                  <img *ngIf="list?.visibility === 0" src="../../../../assets/icons/fill/icon-lock.svg" alt="">
                  <span>
                    {{'LISTS.private_list' | translate}}
                  </span>
                </div>
              </div>
              <app-item-rating *ngIf="(list?.user?.subscriptions | checkActiveRole) === UserRoles.expert || (list?.user?.subscriptions | checkActiveRole) === UserRoles.company" [averageRating]="list?.average_rating"
                [reviewsCount]="list?.reviews_count"></app-item-rating>
            </div>
            <span class="title-single-list">{{list | matchLocale}}</span>
            <div class="wrapper-info-author-list">
              <div class="wrapper-image-author-list">
                <img *ngIf="(list?.user?.subscriptions | checkActiveRole) !== UserRoles.expert"
                  [src]="list?.user?.profile_photo_url !== null ? list?.user?.profile_photo_url :  '../../../../assets/images/avatar-user.png'"
                  alt="">
                <img *ngIf="(list?.user?.subscriptions | checkActiveRole) === UserRoles.expert"
                  [src]="list?.user?.profile_photo_url !== null ? list?.user?.profile_photo_url : '../../../../assets/images/avatar-user-expert.png'"
                  alt="">
              </div>
              <div class="info-author-list">
                <div [routerLink]="[PAGES_AND_PATHS.profile.pagePath, list?.user?.username]" class="wrapper-username">
                  <span>{{list?.user.name}}</span>
                  <img *ngIf="(list?.user?.subscriptions | checkActiveRole) === UserRoles.expert" src="../../../../assets/icons/fill/icon-badge.svg" alt="">
                  <img *ngIf="(list?.user?.subscriptions | checkActiveRole) === UserRoles.company" src="../../../../assets/icons/fill/icon-fill-company.svg" alt="">
                </div>
                <div class="tl-d-flex tl-align-center">
                  <span class="date-list">
                    <p>{{'NEW_TEXT.created_at' | translate}}</p>{{list?.created_at | date:'d MMMM y'}},</span>
                  <span class="date-list"><p>{{'NEW_TEXT.updated_at' | translate}}</p>{{list?.updated_at | date:'d MMMM y'}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="wrapper-likes-and-more-btn">
          <div class="wrapper-likes">
            <button (click)="addListerToFavorites()" class="custom-btn custom-btn--circle-outline">
              <img *ngIf="!list?.am_i_favorite_this_lyst" class="no-like"
                src="../../../../assets/icons/outline/icon-heart.svg" alt="">
              <img *ngIf="list?.am_i_favorite_this_lyst" class="like" src="../../../../assets/icons/fill/icon-heart.svg"
                alt="">
            </button>
            <span [routerLink]="[PAGES_AND_PATHS.listLikes.pagePath, list?.id, 'list']">{{list?.favorite_users_count}}
              {{list?.favorite_users_count === 1 ?( 'LISTS.like' | translate): ('LISTS.likes' | translate)}}</span>
            <button *ngIf="list?.user_id !== loggedUser.id" (click)="openCopyModal()"
              class="custom-btn custom-btn--outline-white">
              <img *ngIf="!isCopied" src="./assets/icons/outline/icon-plus.svg" alt="">
              <img *ngIf="isCopied" src="./assets/icons/outline/icon-check.svg" alt="">
              <span *ngIf="!isCopied">{{'LIST_SINGLE_PAGE.copy_to_my_lists' | translate}}</span>
              <span *ngIf="isCopied">{{'NEW_TEXT.copied' | translate}}</span>
            </button>
          </div>
          <div class="wrapper-dropdown-btn" appClickedOutside (clickedOutside)="isViewMoreModalOpen = false">
            <button (click)="openDropdown($event)" class="custom-btn custom-btn--circle-outline">
              <img src="../../../../assets/icons/outline/icon-view-more.svg" alt="">
            </button>
            <div *ngIf="isViewMoreModalOpen" class="content-dropdown-btn">
              <div *ngIf="list?.user_id === loggedUser.id" [routerLink]="[PAGES_AND_PATHS.updateList.pagePath, listId]"
                class="item-dropdown">
                <img src="../../../../assets/icons/outline/icon-edit.svg" alt="">
                <span>
                  {{'LIST_SINGLE_PAGE.edit_list_information' | translate}}
                </span>
              </div>
              <div *ngIf="list?.user_id === loggedUser.id" class="item-dropdown">
                <img
                  [src]="list?.visibility === 0 ? '../../../../assets/icons/outline/icon-global.svg' : '../../../../assets/icons/outline/icon-lock.svg'"
                  alt="">
                <span *ngIf="list?.user_id === loggedUser.id" (click)="openVisibilityModal()">Make {{list?.visibility === 0 ? 'public' : 'private'}} </span>
              </div>
              <div *ngIf="list?.user_id === loggedUser.id" (click)="print()" class="item-dropdown">
                <img src="../../../../assets/icons/outline/icon-printer.svg" alt="">
                <span>
                  {{'LIST_SINGLE_PAGE.print_list' | translate}}
                </span>
              </div>
              <div (click)="isShareProfileModalOpen = true" class="item-dropdown">
                <img src="../../../../assets/icons/outline/icon-share.svg" alt="">
                <span>
                  {{'GENERAL.share' | translate}}
                </span>
              </div>
              <div *ngIf="list?.user_id !== loggedUser.id" (click)="isReportModalOpen = true" class="item-dropdown delete">
                <img src="./assets/icons/outline/icon-outline-attention.svg" alt="">
                <span>
                  {{'LIST_SINGLE_PAGE.report' | translate}}
                </span>
              </div>
              <div *ngIf="list?.user_id === loggedUser.id" (click)="openDeleteModal()" class="item-dropdown delete">
                <img src="../../../../assets/icons/outline/icon-delete.svg" alt="">
                <span>
                  {{'LIST_SINGLE_PAGE.delete_list' | translate}}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="wrapper-custom-tabs">
          <div class="custom-tab" [ngClass]="{'active': tabSelected === 'cards' || tabSelected === 'table'}"
            [routerLink]="[PAGES_AND_PATHS.singleList.pagePath, listId, 'cards']">
            <img src="../../../../../assets/icons/outline/icon-my-lists.svg" alt="">
            <span>
              {{'LIST_SINGLE_PAGE.items' | translate}}
            </span>
          </div>
          <div class="custom-tab" [ngClass]="{'active': tabSelected === 'posts'}"
            [routerLink]="[PAGES_AND_PATHS.singleList.pagePath, listId, 'posts']">
            <img src="../../../../../assets/icons/outline/icon-posts.svg" alt="">
            <span>
              {{'GENERAL.posts' | translate}}
            </span>
          </div>
          <div *ngIf="(list?.user?.subscriptions | checkActiveRole) === UserRoles.expert || (list?.user?.subscriptions | checkActiveRole) === UserRoles.company" class="custom-tab"
            [ngClass]="{'active': tabSelected === 'reviews'}"
            [routerLink]="[PAGES_AND_PATHS.singleList.pagePath, listId, 'reviews']">
            <img src="../../../../assets/icons/outline/icon-review.svg" alt="">
            <span>
              {{'GENERAL.reviews' | translate}}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="wrapper-content-single-list">
      <div class="content-single-list">
        <app-items *ngIf="tabSelected === 'cards' || tabSelected === 'table'"
                   [items]="items"
                   [columns]="columns"
                   [filters]="filters"
                   [user_id]="list?.user_id"
                   (searchTermChanged)="onSearchTermChanged($event)"
                   (openColumnIdeas)="areColumnsIdeasOpen = $event"
                   (areItemsLoading)="isAiLoading = $event;cdr.detectChanges()"
                   (errorAutopopulate)="isAiError = $event;cdr.detectChanges()"
        ></app-items>
        <app-posts *ngIf="tabSelected === 'posts'" [id]="listId" [isList]="true" [list]="list"></app-posts>
        <app-reviews *ngIf="tabSelected === 'reviews'" [reviewObj]="list" [isList]="true"
          (refreshSinglePage)="getSingleList()"></app-reviews>
      </div>
    </div>
  </div>
</div>
<app-change-visibility-modal *ngIf="isChangeVisibilityModalOpen || isCopyListModalOpen"
  (changeVisibility)="takeAction()" (closeModal)="isChangeVisibilityModalOpen = false; isCopyListModalOpen = false"
  [modalTitle]="modalText.title" [confirmBtnText]="modalText.button"
  [modalDescription]="modalText.description"></app-change-visibility-modal>
<tl-confirm-modal *ngIf="isDeleteModalOpen" [modalIcon]="'../../../../../assets/icons/outline/icon-delete.svg'"
  [modalTitle]="modalText.title" [confirmBtnText]="modalText.button" [modalDescription]="modalText.description"
  (cancelModal)="isDeleteModalOpen = false" (confirmModal)="deleteList()">
</tl-confirm-modal>
<tl-sharing-options-modal *ngIf="isShareProfileModalOpen" [entityType]="ShareEntitiesEnums.lysts" [entityId]="listId"
  [urlForShare]="listUrl" (closeModal)="isShareProfileModalOpen = false; isViewMoreModalOpen = false;">
</tl-sharing-options-modal>
<app-report-modal *ngIf="isReportModalOpen" [entityId]="list.id" [entityType]="'list'"
  (closeModal)="isReportModalOpen = false" (reportSent)="isReportModalOpen = false"></app-report-modal>

<!-- Suggested columns modal -->
<app-suggested-columns *ngIf="areColumnsIdeasOpen"
                       [listId]="listId"
                       (closeModal)="areColumnsIdeasOpen = false"
                       (dataLoading)="isAiLoading = $event;cdr.detectChanges()"
                       (refreshPage)="getSingleList()"
></app-suggested-columns>

<!-- Modal AI loading -->
<div *ngIf="isAiLoading" class="wrapper-modal-ai-loading">
  <img src="../../../../assets/icons/outline/icon-loading-ai.svg" alt="">
  <span>{{'NEW_TEXT.thelysts_ai_is_working_please_wait' | translate}}</span>
</div>

<div *ngIf="isAiError" class="wrapper-modal-ai-loading">
  <img src="../../../../assets/icons/outline/icon-error-ai.svg" alt="">
  <span>{{'NEW_TEXT.we_are_not_able_to_process_your_request_right_now_please_try_changing_your_column_names_to_something_else' | translate}}</span>.
  <button class="custom-btn custom-btn--outline" (click)="isAiError = false"><span>{{'NEW_TEXT.continue' | translate}}</span></button>
</div>

<!--<div *ngIf="selectedMedia !== null" class="wrapper-preview-media">-->
<!--  <img class="image-preview" [src]="selectedMedia" alt="">-->
<!--  <div class="btns-preview-media">-->
<!--    <button (click)="selectedMedia = null" class="custom-btn custom-btn&#45;&#45;circle-outline">-->
<!--      <img src="../../../../assets/icons/outline/icon-close-modal.svg" alt="">-->
<!--    </button>-->
<!--  </div>-->
<!--</div>-->

<app-preview-media *ngIf="selectedMedia !== null"
                   [photoPreview]="true"
                   [selectedMedia]="selectedMedia"
                   (closeModal)="selectedMedia = null">
</app-preview-media>
